import type { IDashboardRepository } from "@/application/ports/repositories";
import type {
  DashboardMetrics,
  DashboardMetricsParams,
  InvestmentAggregationMetrics,
  InvestmentAggregationMetricsParams,
} from "@/domain/dashboard";
import * as sdk from "../generated/sdk.gen";
import { toInvestmentFilterQuery } from "../investmentFilterQuery";
import { unwrap } from "../unwrap";

export class DashboardRepository implements IDashboardRepository {
  async getMetrics(
    params: DashboardMetricsParams = {},
    signal?: AbortSignal,
  ): Promise<DashboardMetrics> {
    return unwrap(sdk.getDashboardMetrics({ query: params, signal }));
  }
  async getInvestmentMetrics(
    params: InvestmentAggregationMetricsParams = {},
    signal?: AbortSignal,
  ): Promise<InvestmentAggregationMetrics> {
    return unwrap(sdk.getInvestmentMetrics({ query: toInvestmentFilterQuery(params), signal }));
  }
}
